<script setup lang="ts">

import {OrderService} from "@/api/api.ts";
import {Md5} from "ts-md5";
import {dayjs, ElNotification} from "element-plus";
import {ref} from "vue";

let courseId = 0
const isShowing = ref(false)
const name = ref('')
const phone = ref('')
const date = ref('')

const emit = defineEmits(['on-add-success'])

const addStudent = async () => {
  try {
    let startTime = undefined
    if (date.value) {
      startTime = dayjs(date.value).startOf('minutes').unix()
    }
    const res = await OrderService.addCourseApply({
      key: Md5.hashStr("微同课" + dayjs().format("YYYY-MM-DD HH:mm")),
      course_id: courseId,
      name: name.value,
      phone: phone.value,
      view_start_time: startTime
    })
    if (res.data.code === 200) {
      ElNotification.success({
        title: '添加成功',
        message: res.data.msg,
      })
      hide()
      emit('on-add-success')
    } else {
      ElNotification.error({
        title: '添加失败',
        message: res.data.msg,
      })
    }
  } catch (error) {
    console.log(error)
  }
}

const show = (_courseId: number) => {
  courseId = _courseId
  isShowing.value = true
}

const hide = () => {
  isShowing.value = false
}

defineExpose({
  show, hide
})
</script>

<template>
  <el-dialog v-model="isShowing" @close="hide" align-center title="添加学生">
    <el-form label-width="100px">
      <el-form-item label="姓名">
        <el-input v-model="name" placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input v-model="phone" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="观看开始时间">
        <el-date-picker datetime v-model="date" type="datetime" placeholder="选择观看开始时间(可不填)"></el-date-picker>
      </el-form-item>
      <div class="flex justify-center items-center mt-1rem">
        <el-button type="primary" @click="addStudent">提交</el-button>
        <el-button type="primary" plain @click="hide">取消</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<style scoped>
</style>
